import React from 'react';
import { useLocalHistory } from 'lib/useLocalHistory';
import { useRouteScenario } from 'src/hooks/useRouteScenario';
import { ROUTES } from 'pages/routes';
import { makeRouteScenario } from 'src/utils/route';
import { OrderScenario } from 'components/order/model/Order';
import { useParams } from 'react-router';

export function useDeliveryScenarioGuard(redirectRoute = ROUTES.DELIVERY.ENTRY) {
    const [scenario] = useRouteScenario();
    const { locationId } = useParams();
    const { getParsedPath, replace } = useLocalHistory();
    const redirectUrl = React.useMemo(
        () =>
            getParsedPath(redirectRoute, {
                scenario: makeRouteScenario(OrderScenario.DELIVERY),
                locationId: locationId ?? ''
            }),
        [getParsedPath, locationId, redirectRoute]
    );
    React.useEffect(() => {
        if (scenario !== OrderScenario.DELIVERY) {
            replace(redirectUrl);
        }
    }, [redirectUrl, replace, scenario]);
}
